import { defineMessages } from 'react-intl'

export const SUBSCRIPTION_PLAN = {
  EARLY_BIRD_PREMIUM: 'EARLY_BIRD_PREMIUM',
  PREMIUM: 'PREMIUM',
  PREMIUM_YEARLY: 'PREMIUM_YEARLY',
  PREMIUM_2025: 'PREMIUM_2025',
  PREMIUM_YEARLY_2025: 'PREMIUM_YEARLY_2025',

  PREMIUM_PLUS_2025: 'PREMIUM_PLUS_2025',
  PREMIUM_PLUS_2025_BETA: 'PREMIUM_PLUS_2025_BETA',
  PREMIUM_PLUS_YEARLY_2025: 'PREMIUM_PLUS_YEARLY_2025',
  PREMIUM_PLUS_UPGRADE_2025: 'PREMIUM_PLUS_UPGRADE_2025',
  PREMIUM_PLUS_YEARLY_UPGRADE_2025: 'PREMIUM_PLUS_YEARLY_UPGRADE_2025',
  PREMIUM_PLUS_SALE_2025: 'PREMIUM_PLUS_SALE_2025',
  PREMIUM_PLUS_YEARLY_SALE_2025: 'PREMIUM_PLUS_YEARLY_SALE_2025',

  // Deprecated
  EARLY_BIRD_PREMIUM_YEARLY: 'EARLY_BIRD_PREMIUM_YEARLY',
  EARLY_BIRD_COACHING: 'EARLY_BIRD_COACHING',
  COACHING: 'COACHING',
  EARLY_BIRD_PREMIUM_CREATOR_COACHING: 'EARLY_BIRD_PREMIUM_CREATOR_COACHING',
  PREMIUM_CREATOR_COACHING: 'PREMIUM_CREATOR_COACHING',
  CREATOR_COACHING: 'CREATOR_COACHING',
  CREATOR_COACHING_STANDARD: 'CREATOR_COACHING_STANDARD',
  CREATOR_COACHING_PRO: 'CREATOR_COACHING_PRO',
  CREATOR_COACHING_EARLY_BIRD: 'CREATOR_COACHING_EARLY_BIRD',
  CHALLENGE_SS30_EARLY_BIRD: 'CHALLENGE_SS30_EARLY_BIRD',
  CHALLENGE_SS30: 'CHALLENGE_SS30'
}

export const SUBSCRIPTION_PLANS_WORKOUT = [
  SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM,
  SUBSCRIPTION_PLAN.PREMIUM,
  SUBSCRIPTION_PLAN.PREMIUM_YEARLY,
  SUBSCRIPTION_PLAN.PREMIUM_2025,
  SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025
]
export const SUBSCRIPTION_PLANS_PREMIUM = SUBSCRIPTION_PLANS_WORKOUT

export const SUBSCRIPTION_PLANS_WORKOUT_AND_NUTRITION = [
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025_BETA,
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025,
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025,
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025,
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025,
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025,
  SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025
]
export const SUBSCRIPTION_PLANS_PREMIUM_PLUS = SUBSCRIPTION_PLANS_WORKOUT_AND_NUTRITION

export const SUBSCRIPTION_PLAN_PRICE = {
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM]: 2.99,
  [SUBSCRIPTION_PLAN.PREMIUM]: 4.99,
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY]: 45,
  [SUBSCRIPTION_PLAN.PREMIUM_2025]: 6.99,
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025]: 62.99,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025_BETA]: 0,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025]: 9.99,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025]: 89.99,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025]: 8.49,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025]: 77.99,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]: 8.49,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]: 77.99,

  // Deprecated
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_YEARLY]: 45,
  [SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING]: 69,
  [SUBSCRIPTION_PLAN.COACHING]: 99,
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_CREATOR_COACHING]: 59.99,
  [SUBSCRIPTION_PLAN.PREMIUM_CREATOR_COACHING]: 99.95,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING]: 99.95,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_STANDARD]: 8,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_PRO]: 9,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_EARLY_BIRD]: 10,
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30_EARLY_BIRD]: 39.99
}

export const SUBSCRIPTION_PLAN_TO_MONTHLY_PRICE = {
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM]: 2.99,
  [SUBSCRIPTION_PLAN.PREMIUM]: 4.99,
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY]: 3.75,
  [SUBSCRIPTION_PLAN.PREMIUM_2025]: 6.99,
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025]: 5.25,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025_BETA]: 0,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025]: 9.99,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025]: 7.49,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025]: 8.49,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025]: 6.50,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]: 8.49,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]: 6.50,

  // Deprecated
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_YEARLY]: 3.75,
  [SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING]: 69,
  [SUBSCRIPTION_PLAN.COACHING]: 99,
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_CREATOR_COACHING]: 59.99,
  [SUBSCRIPTION_PLAN.PREMIUM_CREATOR_COACHING]: 99.95,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING]: 99.95,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_STANDARD]: 8,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_PRO]: 9,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_EARLY_BIRD]: 10,
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30_EARLY_BIRD]: 39.99
}

export const SUBSCRIPTION_PLAN_TO_DISCOUNT_PERCENT = {
  // Base (no discount)
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025]: 0,

  // Standard 25% off yearly
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025]: 25,
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_YEARLY]: 25,
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY]: 25,
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025]: 25,

  // Sale and Upgrade yearly – 35% off base
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]: 35,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025]: 35,

  // Monthly sale & upgrade – 15% off
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]: 15,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025]: 15,

  // Flat-priced coaching plans – no discount calculated
  [SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING]: null,
  [SUBSCRIPTION_PLAN.COACHING]: null,
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_CREATOR_COACHING]: null,
  [SUBSCRIPTION_PLAN.PREMIUM_CREATOR_COACHING]: null,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING]: null,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_STANDARD]: null,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_PRO]: null,
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_EARLY_BIRD]: null,

  // Flat challenge product
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30_EARLY_BIRD]: null,

  // Non-yearly monthly plans – leave null if discount not defined
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM]: null,
  [SUBSCRIPTION_PLAN.PREMIUM]: null,
  [SUBSCRIPTION_PLAN.PREMIUM_2025]: null,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025_BETA]: null
}

export const SUBSCRIPTION_PLAN_TO_SALE_DURATION_IN_HOURS = {
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]: 72,
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]: 72
}

export const SUBSCRIPTION_PLAN_NAME = {
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM]: 'Early Bird Premium ⭐️',
  [SUBSCRIPTION_PLAN.PREMIUM]: 'Premium ⭐️',
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY]: 'Premium Yearly ⭐️',
  [SUBSCRIPTION_PLAN.PREMIUM_2025]: 'Premium ⭐️',
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025]: 'Premium Yearly ⭐️',

  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025_BETA]: 'Premium Plus 💎',
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025]: 'Premium Plus 💎',
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025]: 'Premium Plus Yearly 💎',
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025]: 'Premium Plus 💎',
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025]: 'Premium Plus Yearly 💎',
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]: 'Premium Plus 💎',
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]: 'Premium Plus Yearly 💎',
  // Deprecated
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_YEARLY]: 'Early Bird Premium Yearly',
  [SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING]: 'Early Bird Coaching',
  [SUBSCRIPTION_PLAN.COACHING]: 'Coaching',
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_CREATOR_COACHING]: 'Early Bird Premium Creator',
  [SUBSCRIPTION_PLAN.PREMIUM_CREATOR_COACHING]: 'Premium Creator',
  [SUBSCRIPTION_PLAN.CREATOR_COACHING]: 'Creator',
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_STANDARD]: 'Creator Standard',
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_PRO]: 'Creator Pro',
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_EARLY_BIRD]: 'Creator Early Bird',
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30_EARLY_BIRD]: 'Challenge SS30 Early Bird',
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30]: 'Challenge SS30'
}

export const SUBSCRIPTION_PLAN_MESSAGE_NAME = defineMessages({
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM]: {
    id: 'SubscriptionPlan.earlyBirdPremium',
    defaultMessage: 'Early Bird Premium ⭐️'
  },
  [SUBSCRIPTION_PLAN.PREMIUM]: {
    id: 'SubscriptionPlan.premium',
    defaultMessage: 'Premium ⭐️'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY]: {
    id: 'SubscriptionPlan.premiumYearly',
    defaultMessage: 'Premium Yearly ⭐️'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_2025]: {
    id: 'SubscriptionPlan.premium2025',
    defaultMessage: 'Premium ⭐️'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025]: {
    id: 'SubscriptionPlan.premiumYearly2025',
    defaultMessage: 'Premium Yearly ⭐️'
  },

  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025_BETA]: {
    id: 'SubscriptionPlan.premiumPlus2025',
    defaultMessage: 'Premium Plus 💎'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025]: {
    id: 'SubscriptionPlan.premiumPlus2025',
    defaultMessage: 'Premium Plus 💎'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025]: {
    id: 'SubscriptionPlan.premiumPlusYearly2025',
    defaultMessage: 'Premium Plus Yearly 💎'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025]: {
    id: 'SubscriptionPlan.premiumPlusUpgrade2025',
    defaultMessage: 'Premium Plus 💎'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025]: {
    id: 'SubscriptionPlan.premiumPlusYearlyUpgrade2025',
    defaultMessage: 'Premium Plus Yearly 💎'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025]: {
    id: 'SubscriptionPlan.premiumPlusSale2025',
    defaultMessage: 'Premium Plus 💎'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025]: {
    id: 'SubscriptionPlan.premiumPlusYearlySale2025',
    defaultMessage: 'Premium Plus Yearly 💎'
  },

  // Deprecated
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_YEARLY]: {
    id: 'SubscriptionPlan.earlyBirdPremiumYearly',
    defaultMessage: 'Early Bird Premium Yearly'
  },
  [SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING]: {
    id: 'SubscriptionPlan.earlyBirdCoaching',
    defaultMessage: 'Early Bird Coaching'
  },
  [SUBSCRIPTION_PLAN.COACHING]: {
    id: 'SubscriptionPlan.coaching',
    defaultMessage: 'Coaching'
  },
  [SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM_CREATOR_COACHING]: {
    id: 'SubscriptionPlan.earlyBirdPremiumCreator',
    defaultMessage: 'Early Bird Premium Creator'
  },
  [SUBSCRIPTION_PLAN.PREMIUM_CREATOR_COACHING]: {
    id: 'SubscriptionPlan.premiumCreator',
    defaultMessage: 'Premium Creator'
  },
  [SUBSCRIPTION_PLAN.CREATOR_COACHING]: {
    id: 'SubscriptionPlan.creator',
    defaultMessage: 'Creator'
  },
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_STANDARD]: {
    id: 'SubscriptionPlan.creatorStandard',
    defaultMessage: 'Creator Standard'
  },
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_PRO]: {
    id: 'SubscriptionPlan.creatorPro',
    defaultMessage: 'Creator Pro'
  },
  [SUBSCRIPTION_PLAN.CREATOR_COACHING_EARLY_BIRD]: {
    id: 'SubscriptionPlan.creatorEarlyBird',
    defaultMessage: 'Creator Early Bird'
  },
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30_EARLY_BIRD]: {
    id: 'SubscriptionPlan.challengeSS30EarlyBird',
    defaultMessage: 'Challenge SS30 Early Bird'
  },
  [SUBSCRIPTION_PLAN.CHALLENGE_SS30]: {
    id: 'SubscriptionPlan.challengeSS30',
    defaultMessage: 'Challenge SS30'
  }
})
